import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { DataProviderInstance } from '../../api/DataProvider';
import SectionPanel from '../section-panel/SectionPanel';
import CustomButton from '../buttons/CustomButton';
import { insuranceCardLabel } from '../../pages/appointments/v2/utils/billingType';
import styles from './PatientInsuranceSummaryPanel.module.css';

/**
 * Bloco "Convênio" do popup de edição do cadastro: só leitura das carteirinhas
 * ativas e o atalho para a seção Convênio da ficha, onde elas são gerenciadas.
 * Não aparece sem operadora ativa na empresa nem no cadastro novo (quem usa decide).
 */
function PatientInsuranceSummaryPanel({ patientId, onNavigate }) {
    const { CompanyConfig, GetPatientInsurances } = DataProviderInstance();
    const navigate = useNavigate();
    const hasProviders = (CompanyConfig?.InsuranceProviders || []).length > 0;

    const [cards, setCards] = useState(null);

    useEffect(() => {
        if (!hasProviders || patientId === undefined || patientId === null) return;
        GetPatientInsurances(patientId, (result) => {
            const list = result?.status === 'SUCCESS' ? (result.data?.insurances || []) : [];
            setCards(list.filter((card) => Number(card.active ?? 1) === 1));
        });
    }, [patientId, hasProviders, GetPatientInsurances]);

    if (!hasProviders) return null;

    const openRecord = () => {
        if (onNavigate) onNavigate();
        navigate(`/patients/${patientId}?section=insurance`);
    };

    return (
        <SectionPanel
            icon={<BadgeOutlinedIcon />}
            title="Convênio"
            subtitle="Operadora, plano e carteirinha"
            accent="teal"
            aside={(
                <CustomButton
                    style="primary"
                    variant="text"
                    icon={<OpenInNewIcon fontSize="small" />}
                    label="Gerenciar na ficha"
                    onClick={openRecord}
                />
            )}
        >
            {cards === null ? (
                <div className={styles.loading}><CircularProgress size={16} /></div>
            ) : cards.length === 0 ? (
                <span className={styles.empty}>Nenhuma carteirinha ativa.</span>
            ) : (
                <ul className={styles.list}>
                    {cards.map((card) => (
                        <li key={card.id} className={styles.item}>
                            <span className={styles.label}>{card.label || insuranceCardLabel(card)}</span>
                            {card.expired ? <span className={styles.expired}>Vencida</span> : null}
                        </li>
                    ))}
                </ul>
            )}
        </SectionPanel>
    );
}

export default PatientInsuranceSummaryPanel;
